import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWaterProtectionFaucet = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "water-protection-faucet" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 9.75,
			cy: 9,
			r: 4.5
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "cls-1",
			points: "8.25 4.756 8.25 0.75 11.25 0.75 11.25 4.757"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 11.25,
			y1: .75,
			x2: 14.25,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 5.25,
			y1: .75,
			x2: 8.25,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M22.031,21.094a2.156,2.156,0,0,1-4.312,0c0-1.191,1.437-3.594,2.156-3.594S22.031,19.9,22.031,21.094Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M13.647,6.75h3.6a4.5,4.5,0,0,1,4.5,4.5v3H18v-1.5a1.5,1.5,0,0,0-1.5-1.5H13.648"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "cls-1",
			points: "5.853 6.75 0.75 6.75 0.75 11.25 5.853 11.25"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: .75,
			y1: .75,
			x2: .75,
			y2: 17.25
		})
	]
});
export default SvgWaterProtectionFaucet;
